module.exports = __webpack_public_path__ + "img/20190808170955463.9540722b.png";